import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=7b621b15&scoped=true&"
import script from "./EmptyLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=7b621b15&lang=scss&scoped=true&"
import style1 from "./EmptyLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b621b15",
  null
  
)

export default component.exports